import {
  NpcFbaFreightAction,
  NpcFbaFreightActionTypes,
  NpcFbaFreightState
} from '../../types/npcFbaFreight';

const initialState: NpcFbaFreightState = {
  chart: [],
  table: [],
  total: {
    totalQty: 0,
    totalAmount: 0,
    averageAmount: 0
  },
  lists: {
    brands: [],
    categories: [],
    sizes: [],
    productTypes: [],
    inboundSizes: [],
    inboundPlacements: []
  },
  brand: {
    table: [],
    items_table: []
  },
  transaction: {
    table: [],
    totalAmount: 0,
    averageAmount: 0
  },
  analytics: {
    totalShippedQty: 0,
    toQty: 0,
    totalShippingCost: 0,
    averageShippingCost: 0,
    averagePerItem: 0,
    transfers: [],
    toLines: []
  },
  analytics_charts: {
    categoryChart: [],
    packageChart: [],
    totalCategory: {},
    categories: [],
    packages: []
  },
  inbound_fee: {
    total: {
      fee: 0,
      quantity: 0,
      average: 0
    },
    chartAverage: [],
    chartQty: [],
    details: {},
    itemsTable: [],
    transactionsTable: []
  },
  min_date: null,
  loading_lists: true,
  loading_brand: true,
  loading_transaction: true,
  loading_freight: true,
  loading_freight_total: true,
  loading_analytics: true,
  loading_analytics_charts: true,
  loading_inbound_fee: true
};

export const npcFbaFreightReducer = (
  state = initialState,
  action: NpcFbaFreightAction
): NpcFbaFreightState => {
  switch (action.type) {
    case NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT:
      return {
        ...state,
        ...action.payload,
        loading_freight: false
      };
    case NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_TOTAL:
      return {
        ...state,
        total: {
          ...state.total,
          ...action.payload
        },
        loading_freight_total: false
      };
    case NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_BRAND:
      return {
        ...state,
        brand: {
          ...state.brand,
          ...action.payload
        },
        loading_brand: false
      };
    case NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_TRANSACTION:
      return {
        ...state,
        transaction: {
          ...state.transaction,
          ...action.payload
        },
        loading_transaction: false
      };
    case NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_PARAMS:
      return {
        ...state,
        lists: {
          ...state.lists,
          ...action.payload
        },
        loading_lists: false
      };
    case NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_LOADING:
      return {
        ...state,
        loading_freight: true
      };
    case NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_TOTAL_LOADING:
      return {
        ...state,
        loading_freight_total: true
      };
    case NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_BRAND_LOADING:
      return {
        ...state,
        loading_brand: true
      };
    case NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_TRANSACTION_LOADING:
      return {
        ...state,
        loading_transaction: true
      };
    case NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_MINDATE:
      return {
        ...state,
        min_date: action.payload
      };
    case NpcFbaFreightActionTypes.UPDATE_NPC_FBA_FREIGHT_TRANSACTION:
      return {
        ...state,
        transaction: {
          ...state.transaction,
          table: !action.payload
            ? state.transaction.table
            : state.transaction.table.map((t) => {
                if (t.expenseId === action.payload.id)
                  t.message = action.payload.message;
                return t;
              })
        }
      };
    case NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_ANALYTICS:
      return {
        ...state,
        analytics: {
          ...state.analytics,
          ...action.payload?.analytics
        },
        analytics_charts: {
          ...state.analytics_charts,
          ...action.payload?.analytics_charts
        },
        loading_analytics: false
      };
    case NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_ANALYTICS_CHART:
      return {
        ...state,
        analytics_charts: {
          ...state.analytics_charts,
          ...action.payload
        },
        loading_analytics_charts: false
      };
    case NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_ANALYTICS_LOADING:
      return {
        ...state,
        loading_analytics: true
      };
    case NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_ANALYTICS_CHART_LOADING:
      return {
        ...state,
        loading_analytics_charts: true
      };
    case NpcFbaFreightActionTypes.GET_NPC_FBA_FREIGHT_INBOUND_FEE:
      return {
        ...state,
        inbound_fee: {
          ...state.inbound_fee,
          ...action.payload
        },
        loading_inbound_fee: false
      };
    case NpcFbaFreightActionTypes.SET_NPC_FBA_FREIGHT_INBOUND_FEE_LOADING:
      return {
        ...state,
        loading_inbound_fee: true
      };
    case NpcFbaFreightActionTypes.CLEAR_NPC_FBA_FREIGHT:
      return initialState;
    default:
      return state;
  }
};
